<mat-accordion>
    <div class="userprofile-container">
        <!-- <div mat-dialog-content>
            {{message}}
        </div> -->
        <mat-card class="userprofile-details mat-elevation-z3 ">
            <section>
                <h4 class="userprofile-details-header">Assign User Profiles</h4>
            </section>
            <br>
            <br>
            <section class="userprofile-section">
                <div>
                    <mat-form-field  class="first-control" appearance="fill">
                        <mat-label>Select a Profile</mat-label>
                        <mat-select name="profile" [(value)]="selected" [(ngModel)]="selectedProfile">
                            <mat-option *ngFor="let item of profiles" [value]="item">{{item.profile}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </section>
            <br>
            <br>
            <!-- ASSIGN PROFILE BUTTON  -->
            <section class="user-profile-save">
                <button mat-raised-button
                        class="btn-Cancel"
                        type="submit"
                        color="primary"
                        (click)="cancel()"
                        >CANCEL</button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                     
                <button mat-raised-button
                        class="btn-Save"
                        type="submit"
                        color="primary"
                        (click)="saveProfile()"
                        >SAVE</button>       
            </section>
        </mat-card>
    </div>
</mat-accordion>